import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ButtonAutoplayBoxStyle = styled(Box)(({ theme }) => ({
  display:"flex",
  zIndex:"5",
  cursor:"pointer",
  position: "absolute",
  bottom: "7rem",
  right: "1.5rem",
  // autoplay si sposta in alto per evitare sovrapposizioni
  [theme.breakpoints.down("sm")]: {
    bottom: "unset",
    top: "2rem"
  }
}));

export const CounterBoxStyle = styled(Box)(({ theme }) => ({
  border: "2px solid " + theme.customColors.backgroundPrimaryCta,
  borderRadius: "5px",
  textAlign: "center",
  width:"44px",
  backgroundColor: "rgba(255, 255, 255, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "24px",
  color: theme.customColors.backgroundPrimaryCta,
  cursor:"pointer",
  marginRight:"20px"
}));


export const ProgressBoxStyle = styled(Box)<
  BoxProps & { widthMainComponent:string,progress:number }
>(({ theme,widthMainComponent,progress }) => ({
  width:widthMainComponent,
  border: "2px solid " + theme.customColors.backgroundPrimaryCta,
  paddingTop:"2px",
  paddingBottom:"2px",
  borderRadius: "5px",
  textAlign: "center",
  backgroundImage:`linear-gradient(to right, ${theme.customColors.backgroundPrimaryCta}  ${progress}%, rgba(255, 255, 255, 0.5)${progress}%)`,
  cursor:"pointer",
  [theme.breakpoints.down(700)]: {
    paddingTop:"2px",
    paddingBottom:"2px",
    width:"60px"
  }
}));

export const IconBoxStyle = styled(Box)(({ theme }) => ({
  display:"flex",
  alignItems:"center",
  width:"20%",
  [theme.breakpoints.down(700)]: {
    width:"50%"
  }
}));
